import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import SVG from 'react-svg-inline'
import styled, { css } from 'styled-components'
import Loader from '../loader'
import { H6 } from '../texts'
import Waves from '../waves'

// TODO: RESOLVE
// import { Link } from 'react-router-dom'

const TEXT_COLORS = {
  error: 'red',
  disabled: 'disabled',
  loading: 'disabled',
  active: 'turquoise',
  default: 'fontColor'
}

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 20px;

  svg {
    fill: ${p => p.theme.color[p.color]};
  }
`

const NavigationContainer = styled.div`
  display: inline-flex;
  position: relative;
  height: 100%;
`

const NavigationItem = css`
  position: relative;
  height: 100%;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${p => (p.disabled ? 'auto' : 'pointer')};
  :not(:last-child) {
    margin-right: ${props => props.marginright}px;
    }
  /* pointer-events: ${props => (props.disabled ? 'none' : 'auto')}; */
  ${p => p.textcomponent}, svg {
    transition: ${p => p.theme.duration.s} linear;
  }
  svg {
       fill: ${p => p.theme.color[p.color]};
  }
  :hover {
    ${p => p.textcomponent} {
      color: ${p =>
    p.error
      ? p.theme.color.red
      : p.disabled
        ? p.theme.color.disabled
        : p.underlinecolor
          ? p.underlinecolor
          : p.theme.color.turquoise};
    }
    svg {
       fill: ${p =>
    p.error
      ? p.theme.color.red
      : p.disabled
        ? p.theme.color.disabled
        : p.underlinecolor
          ? p.underlinecolor
          : p.theme.color.turquoise};
    }
  }
`

const NavigationItemDiv = styled.div`
  ${NavigationItem};
`

// TODO: RESOLVE
// const NavigationItemLink = styled(Link)`
//   ${NavigationItem};
// `

const Border = styled.div`
  position: absolute;
  bottom: 0;
  left: ${props => props.left}px;
  border-radius: ${props => props.borderRadius}px
    ${props => props.borderRadius}px 0px 0px;
  height: ${props => props.height}px;
  width: ${props => (props.width ? `${props.width}px` : '120px')};
  background-color: ${props =>
    props.customColor ? props.customColor : props.theme.color[props.color]};
  transition: 0.25s linear;
`

export default ({
  items,
  borderRadius = 5,
  borderOverhang = 10,
  marginRight = 25,
  activeElementIndex,
  highlightColor = 'turquoise',
  TextComponent = H6,
  height = 5,
  fontColor = 'gray',
  errorIcon
}) => {
  const [navItemsWidth, setNavItemsWidth] = useState([])
  const navItemRefArray = []
  useEffect(() => {
    setNavItemsWidth(navItemRefArray.map(el => el.offsetWidth))
  }, [items])
  let currentIndex
  try {
    currentIndex = _.isNumber(activeElementIndex)
      ? activeElementIndex
      : items.map(e => e.name).indexOf(items.find(e => e.current).name)
  } catch (e) {
    currentIndex = 0
  }
  const menuItems = items.map((item, index) => {
    const error = item.error
    const disabled = item.disabled || (item.loading && !error)
    const active = currentIndex === index
    const textColor = active
      ? TEXT_COLORS.active
      : error
        ? TEXT_COLORS.error
        : disabled
          ? TEXT_COLORS.disabled
          : fontColor
    const NavigationItemComponent = item.link
      // TODO: RESOLVE
      ? null // NavigationItemLink
      : NavigationItemDiv
    const onClickHandler = disabled || !item.onClick ? null : item.onClick
    return (
      <NavigationItemComponent
        textcomponent={TextComponent}
        onClick={onClickHandler}
        to={item.link && item.link}
        key={item.name}
        ref={ref => (navItemRefArray[index] = ref)}
        disabled={disabled}
        error={error}
        marginright={marginRight}
        underlinecolor={item.underlineColor}
        color={
          active
            ? item.underlineColor
              ? item.underlineColor
              : highlightColor
            : fontColor
        }
      >
        {item.children && item.leftChildren && item.children}
        <TextComponent
          nowrap={true}
          customColor={active && item.underlineColor}
          color={textColor}
        >
          {item.name}
        </TextComponent>
        {item.loading && !error && <Loader />}
        {!item.disabled && <Waves color="turquoise" />}
        {error && errorIcon && (
          <IconContainer color="red">
            <SVG svg={errorIcon} />
          </IconContainer>
        )}
        {item.children && !item.leftChildren && item.children}
      </NavigationItemComponent>
    )
  })
  return (
    <NavigationContainer>
      {navItemsWidth.length > 0 && (
        <Border
          left={
            _.sum(navItemsWidth.slice(0, currentIndex)) +
            currentIndex * marginRight -
            borderOverhang
          }
          width={
            navItemsWidth[currentIndex] &&
            navItemsWidth[currentIndex] + borderOverhang * 2
          }
          color={highlightColor}
          borderRadius={borderRadius}
          height={height}
          customColor={
            items[currentIndex] && items[currentIndex].underlineColor
          }
        />
      )}
      {menuItems}
    </NavigationContainer>
  )
}
